<template>
  <div>
    <ConfiguratorStepNavBar />
    <NavigationSidebar />

    <div v-if="loading" class="configurator-loader">
      <div class="loader-content">
        <b-spinner variant="primary" label="Loading..." class="loader-spinner" />
        <p class="text-muted">Cargando información del configurador</p>
      </div>
    </div>

    <CortinaConfigurator v-else-if="isCortina" />
    <AndenBordeConfigurator v-else-if="isAndenBorde" />
    <PuertaAutomaticaConfigurator v-else-if="isPuertaAutomatica" />
    <ControlAccesoConfigurator v-else-if="isControlAcceso" />
    <GenericoConfigurator v-else-if="isGenerico" />

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import NavigationSidebar from './NavigationSidebar'
import ConfiguratorStepNavBar from './ConfiguratorStepNavBar.vue'
import CortinaConfigurator from './cortina/CortinaConfigurator'
import AndenBordeConfigurator from './andenBorde/Configurator.vue'
import PuertaAutomaticaConfigurator from './puertaAutomatica/Configurator.vue'
import ControlAccesoConfigurator from './controlAcceso/Configurator.vue'
import GenericoConfigurator from './generico/Configurator.vue'

export default {
  name: 'ConfiguratorStepLayout',
  components: {
    NavigationSidebar,
    ConfiguratorStepNavBar,
    CortinaConfigurator,
    AndenBordeConfigurator,
    PuertaAutomaticaConfigurator,
    ControlAccesoConfigurator,
    GenericoConfigurator
  },
  data () {
    return {
      submitalId: Number(this.$route.params.id),
      loading: false
    }
  },
  mounted () {
    if (this.submitalId !== this.submital.id) {
      this.fetchSubmitalAndConfigurable()
      return
    }
    this.fetchConfigurable()
  },
  watch: {
    currentStep (newStep) {
      if (this.$route.params.step === newStep) return

      this.$router.replace({
        name: 'ConfiguratorStepLayout',
        params: { id: this.submitalId, step: newStep }
      })
    },
    '$route.params.step': {
      handler(newStep) {
        if (newStep && newStep !== this.currentStep) {
          this.$store.commit('setCurrentStep', newStep)
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      submital: state => state.configurator.submital,
      currentStep: state => state.configurator.currentStep
    }),
    ...mapGetters([
      'configurableTypeUrlString',
      'isCortina',
      'isSeccional',
      'isCorredizo',
      'isAbatible',
      'isAndenBorde',
      'isPuertaAutomatica',
      'isControlAcceso',
      'isGenerico'
    ])
  },
  methods: {
    fetchConfigurable () {
      if (this.loading) { return }
      this.loading = true
      this.$http.get(`/api/production/submitals/${this.submitalId}/${this.configurableTypeUrlString}/${this.submital.configurable_id}`)
        .then((res) => {
          this.$store.commit('setConfigurable', res.data)
        })
        .catch(e => console.log(e))
        .finally(() => this.loading = false)
    },
    fetchSubmitalAndConfigurable () {
      if (this.loading) { return }
      this.loading = true
      this.$http.get(`/api/production/submitals/${this.submitalId}`)
        .then((res) => {
          const { configurable, quotes, ...submital } = res.data
          this.$store.commit('setConfigurable', configurable)
          this.$store.commit('setSubmital', submital)
        })
        .catch(e => {
          console.log('error',e)
          this.$store.commit('setConfigurable', {})
          this.$store.commit('setSubmital', {})
        })
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>
.configurator-loader {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-content {
  text-align: center;
  background: white;
  padding: 2.5rem 3rem;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.loader-spinner {
  width: 4rem;
  height: 4rem;
}
</style>